<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap v-if="initStatus === 1">
      <v-flex xs12>
        <v-stepper :value="quoteLifeCycle" class="quoteLifeCycle">
          <v-stepper-header>
            <v-stepper-step step="1" :complete="quoteLifeCycle > 1">General</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="quoteLifeCycle > 2">Applicant/Driver</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" :complete="quoteLifeCycle > 3">Vehicle</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" :complete="quoteLifeCycle > 4">Statistics/Excess</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="5" :complete="quoteLifeCycle > 5">Premium</v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-flex>
      <v-flex lg8 xs12 order-lg1 order-xs2>
        <transition name="slide-x-transition" mode="out-in">
          <router-view :getPermitStatusClass="getPermitStatusClass" :getPermitStatusLabel="getPermitStatusLabel"></router-view>
        </transition>
        <!-- The following dialog will work with leaveQuote Mixin (individual module to follow this structure:: just change the title) -->
        <promptLeave title="Motor" v-model="promptLeave" @exit="doExit" @saveAndExit="doSaveAndExit"></promptLeave>
      </v-flex>
      <v-flex lg4 xs12 order-lg2 order-xs1>
        <motor-quick-info></motor-quick-info>
      </v-flex>
    </v-layout>
    <loader v-else :card="false" :height="425" :init="doInit" loadText="Loading Motor Quotation Details..." errorText="Failed to load Motor Quotation Details" :loading="initStatus === 0"></loader>
  </v-container>
</template>

<script>
import PromptLeave from '../../shared/leaveQuote/PromptLeave'
import { leaveQuote } from '../../shared/leaveQuote'
import MotorQuickInfo from './MotorQuickInfo'
import { mtrPermitStatus } from '@/const/underwriting/motor'

export default {
  computed: {
    initStatus() {
      return this.$store.state.agency.quotation.init
    },
    quoteLifeCycle() {
      return this.$store.state.agency.quotation.quoteLifeCycle
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('motorQuoteInit')
    },
    getPermitStatusClass(status) {
      if (status === 'R') {
        return 'referred'
      } else if (status === 'D') {
        return 'declined'
      } else {
        return ''
      }
    },
    getPermitStatusLabel(status) {
      if (status === 'R' || status === 'D') {
        return mtrPermitStatus[status] + ' Status'
      } else {
        return ''
      }
    }
  },
  mounted() {
    if (this.initStatus !== 1) {
      this.doInit()
    }
  },
  components: {
    PromptLeave,
    MotorQuickInfo
  },
  mixins: [
    leaveQuote
  ]
}
</script>

<style lang="scss">
@import "../../../../assets/scss/base.scss";
.referred {
  .v-messages__message {
    color: $warning !important;
  }
}
.declined {
  .v-messages__message {
    color: $error !important;
  }
}
</style>
